export default "__VITE_ASSET__0535fa93__"